/**
 * The palette as values, for the places a class can't reach: SVG strokes and fills, chart
 * series, a QR code's foreground, an org's default `primary_color`. Read from
 * `brand-tokens.json`, the same file the Tailwind preset (and the marketing site) reads.
 */
import tokens from '../../brand-tokens.json';

const c = tokens.color;

export const BRAND = {
  verlo: c.verlo.DEFAULT,
  hover: c.verlo.hover,
  tint: c.verlo.tint,
  paper: c.paper.app,
  surface: c.surface.DEFAULT,
  hairline: c.hairline,
  ink: c.ink.DEFAULT,
  inkSoft: c.ink.soft,
  inkFaint: c.ink.faint,
  signal: {
    warn: { ink: c.signal.warn.DEFAULT, line: c.signal.warn.line, tint: c.signal.warn.tint },
    stop: { ink: c.signal.stop.DEFAULT, line: c.signal.stop.line, tint: c.signal.stop.tint },
    ok: { ink: c.signal.ok.DEFAULT, line: c.signal.ok.line, tint: c.signal.ok.tint },
    info: { ink: c.signal.info.DEFAULT, line: c.signal.info.line, tint: c.signal.info.tint },
  },
};

/** Series colours for a chart, in the order to hand them out: the navy first, then the
 *  signal lines (which read as "up", "down", "watch" where a chart needs that), then the
 *  quieter inks. Seven is as many as one chart should ever need. */
export const CHART_COLORS = [
  BRAND.verlo,
  BRAND.signal.warn.line,
  BRAND.signal.ok.line,
  BRAND.signal.stop.line,
  c.ochre,
  BRAND.hover,
  BRAND.inkFaint,
];
